import React from 'react'
import PropTypes from 'prop-types'
import BaseComponent from "../../../gd-components/base-component/base-component"

import Form from '../../../gd-form/form/form-modal-new/form-modal-new'
import FormManager from '../../../gd-form/common/form-manager'
import FormError from '../../../gd-form/common/form-error/form-error'
import Input from '../../../gd-form/form-element/input/input'

export default class NewProjectCollectionViewModal extends BaseComponent {

    static propTypes = {
        name                : PropTypes.string,

        onSubmit            : PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        const initFormData = {
            name    : _.get(this.props, 'name', ''),
        }

        const formStructure = {
            isFormChanged: true,
            fields: {
                name: {
                    type: 'input',
                    validator: val => _.isNil(val) || val.trim() === '' ? 'No valid characters found' : true
                },
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.onSubmit(result)
    }

    render() {
        return (
            <Form form={this.form} submitLabel="Save">
                <div className="tbl">
                    <div className="row">
                        <div className="label">Name</div>
                        <div className="element">
                            <Input size="big" form={this.form} name="name" />
                            <FormError form={this.form} name="name" />
                        </div>
                    </div>
                </div>
            </Form>
        )
    }
}